module.exports = __webpack_public_path__ + "static/media/federico-beccari.1331ba97.jpg";